"use client";
import {
  useGroup
} from "./R2QZ3KXH.js";
import {
  createComponent,
  createElement,
  createHook
} from "./3ORBWXWF.js";
import {
  __objRest
} from "./4R3V3JGP.js";

// src/composite/composite-group.ts
var useCompositeGroup = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useGroup(props);
    return props;
  }
);
var CompositeGroup = createComponent(
  (props) => {
    const htmlProps = useCompositeGroup(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  CompositeGroup.displayName = "CompositeGroup";
}

export {
  useCompositeGroup,
  CompositeGroup
};
